import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Projectcard from './Projectcard';
import Typography from '@material-ui/core/Typography';
import resumeData from '../../utils/resume-data';
import SwiperCore, { Pagination, Navigation } from 'swiper/core';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import { Swiper, SwiperSlide } from 'swiper/react'
SwiperCore.use([Pagination, Navigation]);

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
        background: 'black',
        width: '100%',
    },
    projectdiv: {
        background: 'black',
        width: '100%',
    },
    heading: {
        color: 'whitesmoke',
        fontSize: '2.5rem',
        textAlign: 'center',
        padding: '2rem',
        '@media (max-width:600px)': {
            fontSize: '1.8rem',
        },
    },
    slide: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    swiper: {
        "& .swiper-button-prev:after, .swiper-button-next:after": {
            fontSize: '1rem',
            color: 'white !important',
        },

        "& .swiper-button-prev, .swiper-button-next": {
            top: '20%',
        },
    },

});

const Projects = () => {
    const classes = useStyles();
    const allProjects = resumeData.project
    return (
        <div className={classes.root}>
            <Typography className={classes.heading} component="h2">
                Featured Projects
            </Typography>
            <Swiper
                spaceBetween={20}
                className={classes.swiper}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}>
                {allProjects.map(project => {
                    return (
                        <SwiperSlide
                            className={classes.slide}
                            key={project.title}>
                            <Projectcard
                                title={project.title}
                                image={project.image}
                                description={project.description}
                                builtwith={project.builtwith}
                                github={project.github}
                                deployed={project.deployed}
                            />
                        </SwiperSlide>
                    )
                })}

            </Swiper>
        </div>
    )
}

export default Projects

